import { render, staticRenderFns } from "./PaymentsV2.vue?vue&type=template&id=1ae6c999&"
import script from "./PaymentsV2.vue?vue&type=script&lang=js&"
export * from "./PaymentsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports